import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const referrerCompanyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReferrerCompanies: builder.query({
      query: filters => {
        const qs = Object.keys(filters).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `referrer_company/?${qs}`;
      },
      providesTags: ['ReferrerCompany'],
    }),
    createReferrerCompany: builder.mutation({
      query: body => ({
        url: 'referrer_company/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ReferrerCompany'],
    })
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetReferrerCompaniesQuery,
  useCreateReferrerCompanyMutation
} = referrerCompanyApi;
